import { Stack } from '@mui/material';
import { useCallback } from 'react';
import { useLocalStorage } from 'react-use';

import { Accordion } from '@/components/Accordion/Accordion';
import { LOCAL_STORAGE_KEYS } from '@/constants/localStorageKeys';
import { DocumentDetailsForm } from '@/modules/documents/DocumentDetailsForm/DocumentDetailsForm';
import { DocumentDetails_DocumentFragment } from '@/modules/documents/graphql/DocumentDetails.generated';
import { localStorageBooleanSerializer } from '@/utils/localStorageSerializers';

import {
  AboutLoadingState,
  DocumentDetailsPageVariant,
} from '../../DocumentDetailsPage.types';

interface AboutSectionProps {
  document: DocumentDetails_DocumentFragment | undefined;
  variant: DocumentDetailsPageVariant;
  aboutLoadingState: AboutLoadingState;
}

export function AboutSection({
  document,
  variant,
  aboutLoadingState,
}: AboutSectionProps) {
  const [accordionExpanded, setAccordionExpanded] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS.DOCUMENT_DETAILS_ABOUT_ACCORDION_EXPANDED,
    true,
    localStorageBooleanSerializer
  );

  const handleAccordionChange = useCallback(
    (expanded: boolean) => {
      setAccordionExpanded(expanded);
    },
    [setAccordionExpanded]
  );

  return (
    <Accordion
      variant="default"
      title="About this document"
      isDefaultExpanded={accordionExpanded}
      onChange={handleAccordionChange}
      withDivider={false}
    >
      <Stack
        spacing={2}
        aria-busy={aboutLoadingState === AboutLoadingState.Loading}
      >
        {aboutLoadingState === AboutLoadingState.Done && document && (
          <DocumentDetailsForm
            document={document}
            showEntity={variant === DocumentDetailsPageVariant.Household}
          />
        )}
      </Stack>
    </Accordion>
  );
}
